import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/ChatAiActionTypes";
import _ from "lodash";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";


// const LEAD_DETAILS_URL = "/framework/api/appLeadDetails";
const ASSET_LISTING_URL = "chatbot/document_list";
const ASSET_UPLOAD_DOC = "chatbot/upload_asset_docs";
const ASSET_INTERNAL_LISTING_URL = "chatbot/docs_list";
const ADD_SELECTED_ASSETS = "chatbot/save_docs";
const DELETE_ASSET = "chatbot/document_delete";
const MULTIPLE_DELETE_ASSET = "chatbot/delete_multiple_doc"
const SEND_PROMPT = "chatbot/send_message";
const PROMPT_LISTING = "chatbot/viewer_list";
const ASSET_MULTIPLE_UPLOAD_DOC = "chatbot/upload_asset_docs_new"
const EDIT_ASSET_INLINE = "chatbot/edit_document";
const GREETING_MSG = "chatbot/greeting_msg";
const ENGAGE_DROPDOWN = "chatbot/trigger_list";

export const cleanUserData = () => {
  return (dispatch) => {
        dispatch({ type: "URL_LISTING", payload: null });
        dispatch({ type: "ENGAGE_LISTING", payload: null });
        dispatch({ type: "TEXT_LISTING", payload: null });
        dispatch({ type: "URL_PROCESSING", payload: false });
        dispatch({ type: "FETCH_EXTERNAL_ASSET_LISTING", payload: null });
        dispatch({ type: "FETCH_INTERNAL_ASSET_LISTING", payload: null });
        dispatch({ type: "EDIT_ENGAGE_DATA", payload: null });
        dispatch({ type: "UPDATED_PROMPT_LIST", payload: null });
        dispatch({ type: "API_CALL_HIDER", payload: "" });
        dispatch({ type: "EDIT_ENGAGE_MEETING_DATA", payload: null });
        dispatch({ type: "PAGINATION_COUNT", payload: 1 });
    };
};

export const paginationCounter = (value) => {
    return (dispatch) => {
        dispatch({ type: "PAGINATION_COUNT", payload: value });
    };
};

export const handleOperationMode = (value) => {
    return (dispatch) => {
        dispatch({ type: "OPERATION_MODE", payload: value });
    };
};

export const cleanQuestionData = () => {
    return (dispatch) => {
        dispatch({ type: "EDIT_ENGAGE_DATA", payload: null });
    };
};

export const setChatAiUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_CHAT_AI", payload: null });
    };
};

export const apiCallHiderStore = (value) => {
    return (dispatch) => {
        dispatch({ type: "API_CALL_HIDER", payload: value });
    };
}; 

// Fetching Url List

export const fetchCrawlUrl = (authToken,url, include) => {
    return async (dispatch) => {
      dispatch({ type: "CRAWL_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "chatbot/add_crawl_url",
          {
            action: "add",
            sub_pages: include,
            url:url
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "CRAWL_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({
              type: types.CRAWLED_URL,
              payload: response.data,
            });
            dispatch({ type: "CRAWL_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
  };
export const addSelectedUrl = (authToken, action, purl, selectedUrls) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "chatbot/save_urls",
          {
            action: action,
            parent_url:purl,
            urls:selectedUrls
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else if (response.data.statusCode == "200") {
            await dispatch(fetchUrlListing(authToken,"", 1))
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
  };
export const fetchUrlListing = (authToken, searchValue, page, loader_flag) => {
    return async (dispatch) => {
      if(loader_flag === ""){dispatch({ type: "TOGGLE_LOADING", payload: true });}
      try {
        const response = await storeApis.post(
          "chatbot/crawl_url_list",
          {
            action: "crawl_list",
            page:page,
            search:searchValue
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            // dispatch({
            //   type: types.URL_LISTING,
            //   payload: null,
            // });
            await dispatch({ type: types.URL_PROCESSING, payload: response.data?.details?.is_process });
            await dispatch({
              type: types.URL_LISTING,
              payload: response.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
        // Toast(err.response, "E");
      }
    };
  };
export const urlDelete = (authToken,obj) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "chatbot/crawl_delete",
          {
            crawl_url:obj.id,
            key:obj.type
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else if (response.data.statusCode == "200") {
            await dispatch(fetchUrlListing(authToken, "", 1));
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            Toast(response.data.message, "S");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};

export const urlDeleteMultiple = (authToken, delArray) => {
    const array = delArray.map((item) => {
      return {
        url: item.url,
        id: item.id
      }
    })
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "chatbot/multiple_crawl_delete",
          {
            urls: array
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else if (response.data.statusCode == "200") {
            await dispatch(fetchUrlListing(authToken, "", 1));
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            Toast(response.data.message, "S");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
  };


// Fetching Url List
// Fetch external chat Ai asset List

export const fetchExternalListing = (authToken, search, page, loader_flag) => {
  return async (dispatch) => {
    if(loader_flag === ""){dispatch({ type: "TOGGLE_LOADING", payload: true });}
    try {
      const response = await storeApis.post(
        ASSET_LISTING_URL,
        {
            action: "list",
            page:page,
            search: search ? search : ""
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_EXTERNAL_ASSET_LISTING,
            payload: response.data.details,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err?.response?.status ?? 500,
      });
    }
  };
};

//Fetch internal chat Ai asset List
export const fetchInternalAssetListing = (authToken, search) => {
  return async (dispatch) => {
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        ASSET_INTERNAL_LISTING_URL,
        {
            action:"list",
            search: search ? search : ""
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_INTERNAL_ASSET_LISTING,
            payload: response.data.details,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err?.response?.status ?? 500,
      });
    }
  };
};

// chat ai multiple asset upload

export const uploadMultipleAssetContent = (authToken, data) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        ASSET_MULTIPLE_UPLOAD_DOC,
        {
          data: data,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "UPLOAD_LOADING", payload: false });
        } else {
          // Toast(response.data.message, "S");
          dispatch(fetchExternalListing(authToken,"",1,""));
          dispatch({ type: "UPLOAD_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({ type: "UPLOAD_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err?.response?.status ?? 500,
      });
    }
  };
};

// chat Ai upload new asset

export const uploadAssetContent = (authToken, data, current, length, max) => {
  let payload = [{
          doc_url: data.doc_url,
          title: data.title,
          id: data.file_index,
          context: "",
          description: data.description,
          client_asset_id: "0"
  }]
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        ASSET_MULTIPLE_UPLOAD_DOC,
        {
          data:payload
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "UPLOAD_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
            if (max === data?.doc_url?.file?.size) {
              await dispatch(fetchExternalListing(authToken,"",1,"pass"));
              dispatch({ type: "UPLOAD_LOADING", payload: false });
              Toast("Assets Uploaded Successfully", "S");
            }
        } else {
          if (max === data?.doc_url?.file?.size) {
            await dispatch(fetchExternalListing(authToken,"",1,"pass"));
            dispatch({ type: "UPLOAD_LOADING", payload: false });
          }
        }
      }
    } catch (err) {
      if (max === data?.doc_url?.file?.size) {
        await dispatch(fetchExternalListing(authToken, "", 1, "pass"));
      }
      dispatch({ type: "UPLOAD_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err?.response?.status ?? 500,
      });
    }
  };
};

// edit inline asset title

export const editInlineAssetData = (authToken, data) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        EDIT_ASSET_INLINE,
        {
          action:"edit",
          document_id:data.id,
          title:data.value,
          description:""
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch(fetchExternalListing(authToken,"",1,""));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// chat Ai sdeleteAssets
export const deleteAssets = (authToken, data, assetType) => {
  let payload;
  if (assetType === "asset_single") {
    payload = {
      document_id: data,
      key: "trained_url",
    }
  } else {
    payload = {
      document_id: data,
    }
  }
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        assetType === "asset_single" ? DELETE_ASSET:MULTIPLE_DELETE_ASSET,
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          await dispatch(fetchExternalListing(authToken,"",1,""));
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// chat Ai addSelectedAsset
export const addSelectedAsset = (authToken, assetData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        ADD_SELECTED_ASSETS,
        {  
            documents: assetData,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          dispatch(fetchExternalListing(authToken,"",1,""));
          // Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

////////////ChatText Api////////////////////////
export const addText = (authToken, text) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/add_text",
        {
            action:"add",
            text: text
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          dispatch(fetchTextListing(authToken, "", 1, ""));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
      // Toast(err.response, "E");
    }
  };
};

export const editText = (authToken, text, detail) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/edit_text",
        {
          text_id: detail.id,
          text: text, 
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          dispatch(fetchTextListing(authToken, "", 1, ""));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
      // Toast(err.response, "E");
    }
  };
};

export const fetchTextListing = (authToken,searchValue,page,loader_flag) => {
  return async (dispatch) => {
    if(loader_flag === ""){dispatch({ type: "TOGGLE_LOADING", payload: true });}
    try {
      const response = await storeApis.post(
        "chatbot/text_list",
        {
          action: "list",
          page:page,
          search:searchValue
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.TEXT_LISTING,
            payload: response.data,
          });
          
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const textDelete = (authToken,obj) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/delete_text",
        {
          text_id:obj.id,
          key:obj.type
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else if (response.data.statusCode == "200") {
          dispatch(fetchTextListing(authToken, "", 1, ""));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
////////////ChatText Api////////////////////////

// chatbot viewer

export const sendPromptText = (authToken, client_id, widget_data, onSuccessTransition, onSuccessList, onSuccess, onFailure, mode, chatid, text, c_a, m_d, p_id, widget_type) => {
  let prompt_payload;
  if (c_a === "" && widget_data.length === 0) {
    prompt_payload = {
      prompt_id:"",
      prompt: text,
      counter_answer:"",
      counter_question: "",
      response_id: "",
      debugger_mode: mode,
      schat_id: chatid,
      client_id_new: client_id,
      answer_length:"30 to 50"
    }
  } else if (widget_data.length !== 0) {
    prompt_payload = {
      prompt_id: p_id,
      prompt: "",
      response_type: "",
      meeting_data: "",
      counter_answer: "",
      counter_question: "",
      response_id: "",
      debugger_mode: mode,
      schat_id: chatid,
      client_id_new: client_id,
      object_type:"",
      widget_type: widget_type,
      type:"default",
      widget_answers: widget_data,
      answer_length:"30 to 50"
    }
  } else {
    prompt_payload = {
      prompt_id: p_id,
      prompt: "",
      response_type: c_a.response_type,
      meeting_data: c_a.response_type !== "calender" ? "" : m_d,
      counter_answer: c_a.response_type !== "calender" ? text : `Meeting is Scheduled for ${m_d.time}, on ${m_d.date}`,
      counter_question: c_a.counter_question,
      response_id: c_a.response_id,
      debugger_mode: mode,
      schat_id: chatid,
      client_id_new: client_id,
      object_type:"",
      widget_type:"text",
      type:"default",
      widget_answers: [],
      answer_length:"30 to 50"
    }
  }
  
  return async (dispatch) => {
    dispatch({ type: "CHAT_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        SEND_PROMPT,
        prompt_payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          await dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          onFailure();
          dispatch({ type: "CHAT_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          await onSuccess();
          await dispatch(promptListing(authToken, onSuccessTransition, onSuccessList, "internal"));
        } else {
          onFailure();
        }
      }
    } catch (err) {
      onFailure();
      dispatch({ type: "CHAT_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

////////// greetingMessage //////////////

export const greetingMessage = (authToken) => {
  return async (dispatch) => {
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get(
        GREETING_MSG,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({ type: "GREETING_MESSAGE_DATA", payload: response.data });
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
      // Toast(err.response, "E");
    }
  };
};

export const cleanFullChat = (authToken, chatId, onSuccessClean, onSuccessTransition, onSuccessList) => {
  return async (dispatch) => {
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/clean_chat",
        {
          chatid: chatId
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch(promptListing(authToken, onSuccessTransition, onSuccessList, "internal"));
          await onSuccessClean();
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
      // Toast(err.response, "E");
    }
  };
};

export const promptListing = (authToken, onSuccessTransition, onSuccessList, path) => {
  return async (dispatch) => {
    // dispatch({ type: "CHAT_LOADING", payload: false });
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        PROMPT_LISTING,
        {
          action: "list",
          limit:"10",
          offset:"0"
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          let data = response?.data?.details?.reverse();
          // let newMessageData = data.map((item, index) => {
          //   item.counter_question = [];  
          //   return item;
          // })
          // console.log("newMessageData", newMessageData);
          await dispatch({ type: "UPDATED_PROMPT_LIST", payload: data });
          await dispatch(paginationCounter(response.data.total_count));
          await onSuccessList(path);
          if (data && data[data?.length-1]?.counter_question?.length !== 0) {
            onSuccessTransition();
          }
          dispatch({ type: "CHAT_LOADING", payload: false });
          // dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err?.response?.status ?? 500,
      });
    }
  };
};

export const promptPaginationListing = (authToken, offset, prevData) => {
  return async (dispatch) => {
    dispatch({ type: "CHAT_LOADING", payload: false });
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        PROMPT_LISTING,
        {
          action: "list",
          limit:"10",
          offset:(offset*10).toString()
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          let tempArray = response.data.details.reverse();
          dispatch({ type: "UPDATED_PROMPT_LIST", payload: tempArray.concat(prevData) });
          dispatch(paginationCounter(response.data.total_count));
          // dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err?.response?.status ?? 500,
      });
    }
  };
};

// chatbot viewer
// chat ai counter question

export const fetchEngageDropdownData = (authToken) => {
  return async (dispatch) => {
    // dispatch({ type: "CHAT_LOADING", payload: false });
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        ENGAGE_DROPDOWN,
        {}
        ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({ type: "SET_DROPDOWN_DATA", payload: response.data});
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const addWidgetQuestions = (authToken, onSuccess, payload, action) => {
  return async (dispatch) => {
    // dispatch({ type: "CHAT_LOADING", payload: false });
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      await payload.map((item) => {
        item.questions.map((i_item) => {
          let value = i_item.response_type;
          i_item.type = value.type;
          i_item.object_type = value.object_type;
          i_item.response_type = value.value;
          i_item.label = value.display;   
          return i_item;
        })
        return item;
      })
      let payloadData = {
        widget_data: payload
      }
      const response = await storeApis.post(
        "widget/create",
        payloadData
        ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          if (response.data.status === "failed") {
            Toast(response.data.message,'E')
            onSuccess("fail",action);
          } else {
            Toast(response.data.message,'S')
            onSuccess("add_lead",action);
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, 'E')
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const addEngageQuestions = (authToken, onSuccess, payload, action) => {
  let payloadData = {
      action: "trigger_data",
      trigger_id: "keywords",
      keyword: null,
      time_duration: payload.time_duration,
      chat_length: payload.chat_length,
      acknowledgement: payload.acknowledgement
  }
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "chatbot/add_counter_question",
        payloadData
        ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else if (response.data.statusCode == "200") {
          if (response.data.status === "failed") {
            console.log("ERROR", response.data.message);
            onSuccess("fail",action);
          }else {
            onSuccess("add_lead", action);
            Toast(response.data.message, "S");
          }
          // dispatch(fetchEngageListing(authToken))
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const dragEngageListing = (authToken, p_id , q_id) => {
    return async (dispatch) => {
      // if(loader_flag === ""){dispatch({ type: "TOGGLE_LOADING", payload: true });}
      try {
        const response = await storeApis.post(
          "chatbot/reorder_questions",
          {
              priority: p_id,
              question_id: q_id
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch(fetchEngageListing(authToken))
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};

export const fetchEngageListing = (authToken,searchValue, page, loader_flag) => {
    return async (dispatch) => {
      if(loader_flag === ""){dispatch({ type: "TOGGLE_LOADING", payload: true });}
      try {
        const response = await storeApis.post(
          "chatbot/counter_questions_list",
          {
            // action: "crawl_list",
            page:page,
            search:searchValue
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({
              type: types.ENGAGE_LISTING,
              payload: response.data,
            });
            
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
}; 

export const fetchLeadListing = (authToken, loader_flag) => {
  return async (dispatch) => {
      if (loader_flag === "") {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
      }
      try {
        const response = await storeApis.post(
          "widget/list",
          {
            page: 1
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({
              type: types.FETCH_LEAD_LISTING,
              payload: response?.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};

export const fetchEditData = (authToken, loader_flag) => {
  return async (dispatch) => {
      if (loader_flag === "") {
        // dispatch({ type: "TOGGLE_LOADING", payload: true });
      }
      try {
        const response = await storeApis.post(
          "widget/edit",
          {
            page: 1
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            await dispatch({ type: "SET_DROPDOWN_DATA", payload: response?.data?.response_types });
            let updatedObject = response.data?.widget_data;
            // if (response.data?.widget_data?.details?.length > 0) {
              let fixTodo = [{
                  group_id: "87",
                  widget_type: "text",
                  priority: 1,
                  questions: [
                      {
                          question: "May I know Your Email ?",
                          label: "Email Id",
                          object_type: "leads",
                          type: "default",
                          options: [],
                          priority: 1,
                          response_type: "email",
                          new_options: []
                      }
                  ],
                  response_types: [
                      "email"
                  ]
                },
                {
                  group_id: "91",
                  widget_type: "text",
                  priority: 1,
                  questions: [
                      {
                          question: "May I know Your Company Website ?",
                          label: "Company Website",
                          object_type: "accounts",
                          type: "default",
                          options: [],
                          priority: 1,
                          response_type: "company_website",
                          new_options: []
                      }
                  ],
                  response_types: [
                      "company_website"
                  ]
              }]
              let group_data = response.data?.widget_data?.details;
              if (group_data?.length === 0) {
                group_data?.unshift(...fixTodo);
              }
              const arrayParentData = await group_data?.map((obj, g_index) => {
                obj.self_id = g_index+1;
                obj.deleted = false;
                if (obj?.questions?.length > 0) {
                  obj.questions.map((inner_obj, s_index) => {
                    inner_obj.self_id = s_index;
                    inner_obj.deleted = false;
                    const option_ids = [];
                    inner_obj.new_options.forEach(obj => {
                        option_ids.push(obj.id);
                    });
                    const resp = response?.data?.response_types?.filter((i_obj) => {
                      if (i_obj.value === inner_obj.response_type) {
                        const data = i_obj.options.filter(obj => {
                          return !option_ids.includes(obj.id);
                        });
                        i_obj.options = data;
                      }
                      return i_obj.value === inner_obj.response_type;
                    })
                    
                    inner_obj.response_type = resp[0];
                    inner_obj.options = inner_obj.new_options;
                    return inner_obj;
                  })
                }
                return obj;
              })
              updatedObject.details = arrayParentData;
            // }
            dispatch({
              type: types.EDIT_ENGAGE_DATA,
              payload: updatedObject,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};

export const editDataFetch = (authToken, loader_flag) => {
    return async (dispatch) => {
      if (loader_flag === "") {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
      }
      try {
        const response = await storeApis.post(
          "chatbot/edit_question",
          {
            page: 1
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            await dispatch({ type: "SET_DROPDOWN_DATA", payload: response?.data?.response_type});
            let question_data = response.data.details;
            const arrayData = question_data.map((obj,a_index) => {
              obj.self_id = a_index;
              obj.deleted = false;
              const resp = response?.data?.response_type.filter((i_obj) => {
                return i_obj.value === obj.response_type;
              })
              obj.response_type = resp[0];
              return obj;
            })
            
            let updatedObject = response.data;
            updatedObject.details = arrayData;
            
            dispatch({
              type: types.EDIT_ENGAGE_DATA,
              payload: updatedObject,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};

export const updateEngageQuestions = (authToken, onSuccess, payload, action ) => {
    let payloadData = {
      action: action,
      trigger_type: "keywords",
      keyword: null,
      time_duration: payload.time_duration,
      chat_length: payload.chat_length,
      acknowledgement: payload.acknowledgement,
      question:payload?.question,
      triggers: payload?.triggers
    }
    return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "chatbot/update_question",
        payloadData
        ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else if (response.data.statusCode == "200") {
          if (response.data.status === "failed") {
            onSuccess("fail",action);
          } else {
            onSuccess("update_lead", action);
            Toast(response.data.message, "S");
          }
          // dispatch(fetchEngageListing(authToken))
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
           Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const engageDelete = (authToken,id) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "chatbot/delete_question",
          {
            question_id: id
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch(fetchEngageListing(authToken, "", 1));
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
  };

// chat ai counter question

// chat ai meeting section

export const editMeetingDataFetch = (authToken,loader_flag) => {
    return async (dispatch) => {
      if (loader_flag === "") {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
      }
      try {
        const response = await storeApis.post(
          "crm_meetings/edit",
          {},
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: types.EDIT_ENGAGE_MEETING_DATA, payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};


export const addMeetingEngageQuestions = (authToken, onSuccess, payload) => {
  return async (dispatch) => {
    // dispatch({ type: "CHAT_LOADING", payload: false });
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "crm_meetings/create",
        {
          question: payload.question,
          acknowledgement: payload.acknowledgement,
          time_duration: payload.time_duration,
          chat_length: payload.chat_length,
          keywords: payload.keyword
        }
        ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          if (response.data.status === "failed") {
            console.log("ERROR", response.data.message);
          }else {
            onSuccess("add_meeting");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const updateMeetingEngageQuestions = (authToken, onSuccess, payload, id) => {
    return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "crm_meetings/update",
        {
          question_id: id,
          question: payload.question,
          acknowledgement: payload.acknowledgement,
          time_duration: payload.time_duration,
          chat_length: payload.chat_length,
          keywords: payload.keyword
        }
        ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          if (response.data.status === "failed") {
            console.log("ERROR", response.data.message);
          } else {
            onSuccess("update_meeting");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};


// chat ai meeting section
// Chat Design 
export const chatDesignData = (authToken, designPayload) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "settings/add_theme",
          designPayload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else if (response.data.statusCode == "200") {
          // dispatch(fetchTextListing(authToken, "", 1, ""));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(fetchChatDesignData(authToken))
          Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchChatDesignData = (authToken) => {
  return async (dispatch) => {
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get(
        "settings/get_theme",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          // dispatch({ type: "CHAT_DESIGN_DATA", payload: null });
          dispatch({ type: "CHAT_DESIGN_DATA", payload: response.data.details });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
export const fetchDesignScreenshot = (authToken) => {
  return async (dispatch) => {
    // dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get(
        "get_screenshots",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          // dispatch({ type: "CHAT_DESIGN_DATA", payload: null });
          dispatch({ type: "CHAT_DESIGN_SCREENSHOT", payload: response?.data?.screenshot_url?.screenshots });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      Toast("Something went wrong", "E");
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
      // Toast(err.response, "E");
    }
  };
};


// Chat Design


// Greeting API

export const greetingData = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/add_greeting_msg",
        {
            action: "list"
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.FETCH_GREETING_DATA,
            payload: response.data.details,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};


export const addGreetingMessage = (authToken, msg) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/add_greeting_msg",
        {
            greeting_msg: msg
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else if (response.data.statusCode == "200") {
          await dispatch(greetingMessage(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
export const addDisclamer = (authToken, payload) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "add_privacy_policy",
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else if (response.data.statusCode == "200") {
          await dispatch(greetingMessage(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const addSuggestion = (authToken, p1, p2, p3) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/add_suggestions",
        {
            data:[
              { question: p1 },
              { question: p2 },
              { question: p3 },
            ]
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          await dispatch(greetingMessage(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};


export const updateSuggestion = (authToken, data) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/update_suggestions",
        {
            data:data
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          
        } else if (response.data.statusCode == "200") {
          await dispatch(greetingMessage(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

///////////////////////////////////////////////////

// Fetch external chat Ai asset List

export const fetchCorrectionListing = (authToken, search, page, path) => {
  return async (dispatch) => {
    if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "finetune/conversation_list",
        {
          search : search,
          page : page
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_CORRECTION_LISTING,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// fetch Correction Popup Data

export const fetchCorrectionPopupData = (authToken, id, onSuccess, type) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "finetune/conversation_details",
        {
          c_history_id: id,
          conversation_type: type
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          onSuccess(response.data.data, "correction");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// save Correction Data

export const saveCorrectionData = (authToken, data, new_answer, type ,path, onSuccessTest) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "finetune/conversation_update",
        {
          id: data?.id || null,
          conversation_type: type,
          c_history_id: data?.c_history_id,
          prompt_id: data?.prompt_id,
          question: data?.question,
          new_answer: new_answer,
          old_answer: data?.old_answer
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          await dispatch(fetchCorrectionListing(authToken, "", 1, "normal"));
          if (path === "test") {
            onSuccessTest(response.data.data, "correction");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const tuningMultipleDelete = (authToken,obj, type, path) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          path !== "Inputs" ? "finetune/conversation_delete":"finetune/manual_delete",
          {
            id:obj
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_CHAT_AI",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else if (response.data.statusCode == "200") {
            if (path !== "Inputs") {
              await dispatch(fetchCorrectionListing(authToken, "", 1, "normal"));
            } else {
              await dispatch(fetchInputListing(authToken, "", 1, "normal"));
            }
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            Toast(response.data.message, "S");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
};

// Fetch external chat Ai asset List

export const fetchInputListing = (authToken, search, page, path) => {
  return async (dispatch) => {
    if (path === "pagination") { dispatch({ type: "TOGGLE_LOADING", payload: true }); }
    try {
      const response = await storeApis.post(
        "finetune/manual_list",
        {
          search : search,
          page : page
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_INPUTS_LISTING,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const saveInputData = (authToken, id, promptId, data, new_answer, path, onSuccessTest) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "finetune/manual_update",
        {
          id: id || null,
          prompt_id: promptId,
          response: new_answer,
          question: data,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          await dispatch(fetchInputListing(authToken, "", 1, "normal"));
          if (path === "test") {
            onSuccessTest(response.data.data, "inputs");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchInputsPopupData = (authToken, id, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "finetune/manual_details",
        {
          id: id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
            await response?.data?.data?.question?.map((item, index) => {
              item.self_id = index + 1;
              item.edit = response?.data?.data?.question?.length === index + 1;
              return item;
            }) 
          await onSuccess(response?.data?.data, "inputs");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};


export const onboardingFlow = (authToken, name ,pass ,repass,uData,companyName,lName,industry) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "onboarding/setPassword",
        {
          first_name:name,
          last_name:lName,
          password:pass,
          confirm_password:repass,
          company_name:companyName,
          onboarding_answer:industry,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Step 1: Update the value of the set_password key to false
          uData.set_password = true;
          uData.set_question = true;
          // Step 2: Save the updated userData object back to localStorage
          localStorage.setItem('userData', JSON.stringify(uData));
          // localStorage.setItem("userData", JSON.stringify(userData));
          window.location.reload();
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
export const onboardingData = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.get(
        "onboarding/setQuestions",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({
            type: "ONBOARDING_DATA",
            payload: response.data?.details,
          });          
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
export const onboardingAnswer = (authToken,qid,selectedItem,uData) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "onboarding/saveAnswer",{
          data:{
            id:qid,
            answer:selectedItem
          }
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          await dispatch(onboardingData(authToken));       
          if(response.data.message === "Last Answer Saved Successfully"){
            window.location.assign(uData?.data?.user_type === 4 ? "/Analytics" : "/Chat-Ai");
            // Step 1: Update the value of the set_password key to false
          uData.set_question = true;
          // Step 2: Save the updated userData object back to localStorage
          localStorage.setItem('userData', JSON.stringify(uData));
          // localStorage.setItem("userData", JSON.stringify(userData));
          }  
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// For Developer Mail
export const sendDeveloperMail = (authToken, value,clientID) => {
  return async (dispatch) => {
     dispatch({ type: "TOGGLE_LOADING", payload: true }); 
    try {
      const response = await storeApis.post(
        "share-embed-code",
        {
          email_data : value,
          client_encoded_id : clientID
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast("Mail Sent", "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// Token 
export const getTokenData = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "UPLOAD_LOADING", payload: true });
    try {
      const response = await storeApis.get(
        "show-prompts",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          // Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({
            type: "TOKEN_DATA",
            payload: response.data.data,
          });          
          dispatch({
            type: "T_DATA",
            payload: response.data,
          });          
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// Carousel Image posting
export const carouselImageSubmit = (authToken, promptNum,imgData,fileData) => {
  return async (dispatch) => {
     dispatch({ type: "TOGGLE_LOADING", payload: true }); 
    try {
      const response = await storeApis.post(
        "query-zoi/upload-images",
        {
          data:{
            prompt_no:promptNum,
            imageUrl:{
              base64:imgData,
              file:fileData,
            }
          }
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(greetingMessage(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast("Image saved", "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};